import { render, staticRenderFns } from "./CustomerDocuments.vue?vue&type=template&id=260c03c9&scoped=true&"
import script from "./CustomerDocuments.vue?vue&type=script&lang=js&"
export * from "./CustomerDocuments.vue?vue&type=script&lang=js&"
import style0 from "./CustomerDocuments.vue?vue&type=style&index=0&id=260c03c9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260c03c9",
  null
  
)

export default component.exports